import React, { useState } from 'react';
import rfqService from '../../services/rfqService';
import './RfqModal.css';

const RfqModal = ({ isOpen, onClose, productName, configurationJson }) => {
    const [formData, setFormData] = useState({
        customerFirstName: '',
        customerLastName: '',
        customerEmail: '',
        customerPhone: '',
        companyName: '',
        zipPostalCode: '',
        country: 'United States',
        specialRequests: ''
    });
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const [referenceNumber, setReferenceNumber] = useState('');

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);

        try {
            const result = await rfqService.create({
                productName,
                configurationJson: JSON.stringify(configurationJson),
                ...formData
            });
            setReferenceNumber(result.referenceNumber);
            setSuccess(true);
        } catch (err) {
            setError(err.message || 'Failed to submit quote request');
        } finally {
            setIsLoading(false);
        }
    };

    const handleClose = () => {
        setFormData({
            customerFirstName: '',
            customerLastName: '',
            customerEmail: '',
            customerPhone: '',
            companyName: '',
            zipPostalCode: '',
            country: 'United States',
            specialRequests: ''
        });
        setError('');
        setSuccess(false);
        setReferenceNumber('');
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div className="rfq-modal-overlay">
            <div className="rfq-modal">
                <div className="rfq-modal-header">
                    <h2>{success ? 'Quote Requested!' : 'Request Quotation'}</h2>
                    <button className="rfq-modal-close" onClick={handleClose}>&times;</button>
                </div>

                {success ? (
                    <div className="rfq-modal-success">
                        <div className="success-icon">✓</div>
                        <p>Your quote request has been submitted successfully.</p>
                        <p className="reference-number">Reference: <strong>{referenceNumber}</strong></p>
                        <p>We will contact you shortly.</p>
                        <button className="rfq-submit-btn" onClick={handleClose}>Close</button>
                    </div>
                ) : (
                    <form onSubmit={handleSubmit}>
                        <div className="rfq-modal-body">
                            {error && <div className="rfq-error">{error}</div>}
                            
                            <div className="rfq-product-info">
                                <strong>Product:</strong> {productName}
                            </div>

                            <div className="rfq-form-row">
                                <div className="rfq-form-group">
                                    <label>First Name *</label>
                                    <input
                                        type="text"
                                        name="customerFirstName"
                                        value={formData.customerFirstName}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="rfq-form-group">
                                    <label>Last Name *</label>
                                    <input
                                        type="text"
                                        name="customerLastName"
                                        value={formData.customerLastName}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                            </div>

                            <div className="rfq-form-row">
                                <div className="rfq-form-group">
                                    <label>Email *</label>
                                    <input
                                        type="email"
                                        name="customerEmail"
                                        value={formData.customerEmail}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="rfq-form-group">
                                    <label>Phone *</label>
                                    <input
                                        type="tel"
                                        name="customerPhone"
                                        value={formData.customerPhone}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                            </div>

                            <div className="rfq-form-group">
                                <label>Company Name *</label>
                                <input
                                    type="text"
                                    name="companyName"
                                    value={formData.companyName}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            <div className="rfq-form-row">
                                <div className="rfq-form-group">
                                    <label>ZIP/Postal Code *</label>
                                    <input
                                        type="text"
                                        name="zipPostalCode"
                                        value={formData.zipPostalCode}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="rfq-form-group">
                                    <label>Country *</label>
                                    <select
                                        name="country"
                                        value={formData.country}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="United States">United States</option>
                                        <option value="Canada">Canada</option>
                                        <option value="Mexico">Mexico</option>
                                        <option value="Other">Other</option>
                                    </select>
                                </div>
                            </div>

                            <div className="rfq-form-group">
                                <label>Special Requests</label>
                                <textarea
                                    name="specialRequests"
                                    value={formData.specialRequests}
                                    onChange={handleChange}
                                    rows="3"
                                    placeholder="Any additional requirements or questions..."
                                />
                            </div>
                        </div>

                        <div className="rfq-modal-footer">
                            <button type="button" className="rfq-cancel-btn" onClick={handleClose}>
                                Cancel
                            </button>
                            <button type="submit" className="rfq-submit-btn" disabled={isLoading}>
                                {isLoading ? 'Submitting...' : 'Submit Request'}
                            </button>
                        </div>
                    </form>
                )}
            </div>
        </div>
    );
};

export default RfqModal;